import { defineMessages } from "react-intl";

const ARE_YOU_SURE_DELETE_MODAL = "are-you-sure-delete-modal";

const areYouSureDeleteModalMessages = defineMessages({
  deleteButton: {
    id: `${ARE_YOU_SURE_DELETE_MODAL}.delete-button`,
    defaultMessage: "Delete my account"
  },
  saveItems: {
    id: `${ARE_YOU_SURE_DELETE_MODAL}.save-items`,
    defaultMessage: "Save and organize your research"
  },
  checkoutBooks: {
    id: `${ARE_YOU_SURE_DELETE_MODAL}.checkout-books`,
    defaultMessage: "Check out library materials through this application"
  },
  accessCredits: {
    id: `${ARE_YOU_SURE_DELETE_MODAL}.access-credits`,
    defaultMessage: "Access your credits and certificates"
  },
  accessContent: {
    id: `${ARE_YOU_SURE_DELETE_MODAL}.access-content`,
    defaultMessage: "Access individually purchased content"
  },
  areYouSureMessage: {
    id: `${ARE_YOU_SURE_DELETE_MODAL}.are-you-sure-message`,
    defaultMessage:
      "You will still be able to anonymously access EBSCO products through your institution."
  },
  areYouSureTitle: {
    id: `${ARE_YOU_SURE_DELETE_MODAL}.are-you-sure-title`,
    description: "Are You Sure Modal Title",
    defaultMessage: "Are you sure?"
  },
  areYouSureListTitle: {
    id: `${ARE_YOU_SURE_DELETE_MODAL}.are-title`,
    defaultMessage:
      "Without a MyEBSCO account you will no longer have the ability to:"
  },
  warningMessage: {
    id: `${ARE_YOU_SURE_DELETE_MODAL}.warning-message`,
    defaultMessage:
      "If you continue, EBSCO will delete your MyEBSCO personal account, including any personal data we've collected that is associated with your account."
  },
  warningMessageExplanation: {
    id: `${ARE_YOU_SURE_DELETE_MODAL}.warning-explanation`,
    defaultMessage:
      "By deleting your account, you are confirming that EBSCO should also delete any items or searches saved, including custom folders and projects created under your MyEBSCO account."
  }
});

export default areYouSureDeleteModalMessages;
